import {
    BanknotesIcon,
    BellAlertIcon,
    BoltIcon,
    Cog6ToothIcon,
    CurrencyDollarIcon,
    EnvelopeIcon,
    FolderIcon,
    HomeIcon,
    ListBulletIcon,
    PhotoIcon,
    PresentationChartBarIcon,
    TicketIcon,
    UserIcon,
} from "@heroicons/react/24/outline";
import SidebarRail from "./SidebarRail";

// Grouped: the two entry points, then the work queues, then catalog and
// pricing, then outbound messaging, then configuration.
const NAV_ITEMS = [
    { to: "/admin/dashboard", match: "dashboard", label: "Dashboard", icon: HomeIcon },
    { to: "/admin/automatic", match: "automatic", label: "Automatic", icon: BoltIcon, badge: "New" },
    { divider: true },
    { to: "/admin/all-files", match: "all-files", label: "All Files", icon: FolderIcon },
    { to: "/admin/all-tickets", match: "all-tickets", label: "All Tickets", icon: TicketIcon },
    { to: "/admin/all-users", match: "all-users", label: "All Users", icon: UserIcon },
    {
        to: "/admin/credits-ledger",
        match: "credits-ledger",
        label: "All Credits History",
        icon: BanknotesIcon,
    },
    { divider: true },
    {
        to: "/admin/solutions",
        match: "solutions",
        label: "Solution Price",
        icon: CurrencyDollarIcon,
    },
    {
        to: "/admin/solution-images",
        match: "solution-images",
        label: "Solution Images",
        icon: PhotoIcon,
    },
    {
        to: "/admin/additional-prices",
        match: "additional-prices",
        label: "Additional Price",
        icon: CurrencyDollarIcon,
    },
    { to: "/admin/price-list", match: "price-list", label: "Price List", icon: ListBulletIcon },
    {
        to: "/admin/login-images",
        match: "login-images",
        label: "Login / Register Images",
        icon: PhotoIcon,
    },
    { divider: true },
    { to: "/admin/email", match: "email", label: "Email", icon: EnvelopeIcon },
    {
        to: "/admin/push-notification",
        match: "push-notification",
        label: "Push Notification",
        icon: BellAlertIcon,
    },
    { to: "/admin/gain", match: "gain", label: "Gain", icon: PresentationChartBarIcon },
    { divider: true },
    {
        to: "/admin/application-configuration",
        match: "application-configuration",
        label: "Configuration",
        icon: Cog6ToothIcon,
    },
];

const AdminSidebar = ({ isOpen, toggleSidebar }) => (
    <SidebarRail
        items={NAV_ITEMS}
        title="VDP Tuning Team"
        subtitle="Admin console"
        subtitleClassName="font-semibold uppercase tracking-[0.12em] text-rose-400"
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
    />
);

export default AdminSidebar;
